// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1a1y4","gfeWrapper":"CalendarEvent_gfeWrapper__2cFta"};